module.exports = __webpack_public_path__ + "static/media/videoToCodeing.e9c66163.jpg";